import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './src/app/routes';
import { ErrorBoundary } from './src/shared/components/ErrorBoundary';
import { Providers } from './src/app/providers';
import { AuthHydrationGate } from './src/shared/components/AuthHydrationGate';
import { initConsoleErrorCapture } from './src/shared/utils/consoleErrorCapture';
import 'tippy.js/dist/tippy.css'; // Tippy.js styles for mention autocomplete
import './src/styles/print.css'; // Print styles for Weekly Task Board

// Initialize console error capture for dev log
initConsoleErrorCapture();

// Build version logging - helps verify deploys are live
declare const __BUILD_HASH__: string;
declare const __BUILD_TIME__: string;
if (typeof __BUILD_HASH__ !== 'undefined') {
  console.log(`[Cenari] Build: ${__BUILD_HASH__} @ ${__BUILD_TIME__}`);
  // Expose on window for quick verification: window.__BUILD_HASH__
  (window as any).__BUILD_HASH__ = __BUILD_HASH__;
  (window as any).__BUILD_TIME__ = __BUILD_TIME__;
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  // StrictMode disabled temporarily for testing (reduces API calls by 50%)
  // <React.StrictMode>
    <ErrorBoundary>
      <Providers>
        {/* AuthHydrationGate waits for Zustand to hydrate from localStorage
            before rendering routes. This prevents the flash of unauthenticated
            content when users navigate directly to protected routes. */}
        <AuthHydrationGate>
          <RouterProvider router={router} />
        </AuthHydrationGate>
      </Providers>
    </ErrorBoundary>
  // </React.StrictMode>
);